import BaseBadge from "./BaseBadge";
export default BaseBadge;